// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input, textarea, select {
   border-style: solid;
   border-width: 1px;
   border-color: rgba(0, 0, 0, 0.12);
   cursor: unset;
   padding: 5px 10px;
}

.txt-field-body {
   border-style: none;
}

.mat-select {
   display: inline-block;
   width: 250px;
   padding: 5px;
   border-bottom: 2px solid #9999999c;
   margin-left: 12px;
   margin-top: 5px;
}

.address-field-body .field-address-body select {
   height: unset;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

.validate-error {
   border-color: red;
}

input:focus, select:focus {
   outline: none !important;
   border:1px solid rgba(0, 0, 0, 0.35);
}

.hide-overflow {
   overflow: unset !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/address/address.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,iBAAiB;GACjB,iCAAiC;GACjC,aAAa;GACb,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,YAAY;GACZ,YAAY;GACZ,kCAAkC;GAClC,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,wBAAwB;GACxB,oCAAoC;AACvC;;AAEA;GACG,0BAA0B;AAC7B","sourcesContent":["input, textarea, select {\n   border-style: solid;\n   border-width: 1px;\n   border-color: rgba(0, 0, 0, 0.12);\n   cursor: unset;\n   padding: 5px 10px;\n}\n\n.txt-field-body {\n   border-style: none;\n}\n\n.mat-select {\n   display: inline-block;\n   width: 250px;\n   padding: 5px;\n   border-bottom: 2px solid #9999999c;\n   margin-left: 12px;\n   margin-top: 5px;\n}\n\n.address-field-body .field-address-body select {\n   height: unset;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\n.validate-error {\n   border-color: red;\n}\n\ninput:focus, select:focus {\n   outline: none !important;\n   border:1px solid rgba(0, 0, 0, 0.35);\n}\n\n.hide-overflow {\n   overflow: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
